import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { getStops } from 'src/app/forms/bookingForms';
import { IServiceAvailability, IStop } from 'src/app/models';
import { TicketingType } from 'src/app/models/enums';
import { IBookingDetails } from 'src/app/models/booking/bookingDetails';
import { BookingsService, TownsService, UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-change-booking-origin-destination',
  templateUrl: './modal-change-booking-origin-destination.component.html',
  styleUrl: './modal-change-booking-origin-destination.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalChangeBookingOriginDestinationComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() originElement: any;
  @Input() destinationElement: any;
  @Input() booking: IBookingDetails;
  @Input() updating: boolean;
  @Input() needsConfirmation?: boolean = false;
  @Output() action = new EventEmitter<any>();
  @Output() onExceededLimit = new EventEmitter<any>();

  public originSelected: any;
  public destinationSelected: any;
  public availabilitySelected: IServiceAvailability;
  public confirmChange = false;
  public notify = true;
  public recomputePrice = false;

  public images = images;
  public optionsBus: AnimationOptions = {
    path: '/assets/animations/bus.json',
  };

  constructor(
    public literalService: LiteralService,
    public townsService: TownsService,
    private bookingsService: BookingsService,
    public utilsService: UtilsService,
  ) {}

  get showRecomputePriceToggle(): boolean {
    if (!this.booking) return false;
    return (
      !!this.booking.ticketingType &&
      this.booking.ticketingType !== TicketingType.None
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.originElement && this.destinationElement) {
      this.originSelected = this.originElement.edit.values.find(
        (stop: IStop) => stop.id === this.originElement.value,
      );
      this.originElement.edit.disabled = false;
      this.destinationSelected = this.destinationElement.edit.values.find(
        (stop: IStop) => stop.id === this.destinationElement.value,
      );
      this.originElement.edit.disabled = false;
    }
    this.confirmChange = false;
  }

  async setOrigin(event: any) {
    const stops: any[] = await getStops(this.townsService, this.booking, event);
    this.destinationElement.edit.values = stops;
    this.originSelected = this.originElement.edit.values.find(
      (stop: IStop) => stop.id === event,
    );
  }

  setDestination(event: any) {
    this.destinationSelected = this.destinationElement.edit.values.find(
      (stop: IStop) => stop.id === event,
    );
  }

  onCancel() {
    if (this.confirmChange) {
      this.originElement.edit.disabled = false;
      this.destinationElement.edit.disabled = false;
      this.confirmChange = false;
    } else this.modal.hide();
  }

  async onSubmit() {
    if (this.needsConfirmation && !this.confirmChange) {
      this.originElement.edit.disabled = true;
      this.destinationElement.edit.disabled = true;
      this.confirmChange = true;
    } else {
      const kmExceeded = await this.bookingsService.isExceedingKmLimit(
        this.booking.userId,
        this.originSelected.id,
        this.destinationSelected.id,
        this.booking.routeId,
        1,
      );
      this.booking.destination = {
        id: this.destinationSelected.id,
        serviceStopId: this.destinationSelected.id,
        name: this.destinationSelected.label,
      };
      this.booking.bookingSeats.map(
        (seat: any) =>
          (seat.exitStop = {
            id: this.destinationSelected.id,
            latLon: {
              id: this.destinationSelected.id,
              latitude: this.destinationSelected.latitude,
              longitude: this.destinationSelected.longitude,
            },
            latitude: this.destinationSelected.latitude,
            longitude: this.destinationSelected.longitude,
            name: this.destinationSelected.label,
          }),
      );
      this.booking.origin = {
        id: this.originSelected.id,
        serviceStopId: this.originSelected.id,
        name: this.originSelected.label,
      };
      if (kmExceeded) this.onExceededLimit.emit(this.booking);
      else {
        this.modal.toggle();
        this.action.emit({
          booking: this.booking,
          sendNotification: this.notify,
          recomputePrice: this.recomputePrice,
        });
      }
    }
  }
}
